// echarts 组件库入口，按需导出
// echats/export.ts
import type { App } from 'vue'
import EChartsBase from '@/components/echarts/index.vue'
import * as presets from '@/components/echarts/module/chart-presets'
import type * as types from '@/components/echarts/type/index.module'

const components = {
  EChartsBase
}

export function install(app: App) {
  app.component('EChartsBase', EChartsBase)
}

export default {
  install
}

export { EChartsBase, presets, types }
